
  import axios from 'axios'
  import { v4 as uuidv4 } from 'uuid'

  export default {
    head() {
      return {
        title: 'Storyboard - Pricing - Upgrade Account',
      }
    },
    data() {
      return {
        messageSubmitted: false,
        success: false,
        form: {
          name: '',
          accountEmail: '',
          numberOfUsers: 0,
          ticketId: '',
        },
        formValidation: {
          name: 'required|name',
          accountEmail: 'required|email',
          numberOfUsers: 'required|numeric',
        },
      }
    },
    methods: {
      createTicketId() {
        return uuidv4().toString().replace('-', '').substring(0, 10)
      },
      encode(data) {
        return Object.keys(data)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
          )
          .join('&')
      },
      handleSubmit(event) {
        this.failure = false
        const axiosConfig = {
          header: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }

        this.form.ticketId = this.createTicketId()
        let formData = event.detail[0]
        formData.ticketId = this.form.ticketId

        axios
          .post(
            location.href,
            this.encode({
              'form-name': 'upgrade-account',
              'subject': `New account upgrade request submitted: ${this.form.ticketId}`,
              ...formData,
            }),
            axiosConfig
          )
          .then((response) => {
            this.messageSubmitted = true
            if (response.status === 200) {
              this.success = true
            }
          })
          .catch(() => {
            this.messageSubmitted = true
            this.success = false
          })
          .finally(() => {
            if (typeof window !== 'undefined' && this.success) {
              // googleads event tracking
              window.dataLayer.push({
                'event': 'conversion',
                'send_to': `${this.$config.googleAdsId}/GBn0CLW0zeMDEKCSrewC`,
              })
            }
          })
      },
    },
  }
